import { getSpacing, SpacingName, ThemedFunctor } from '@doveit/lego';
import { css } from 'styled-components';

export const searchSummary: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.padding(theme, SpacingName.SMALLER)}
  background-color: ${theme.palettes.neutrals.lighter};
`;

export const item: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.margin(theme, [SpacingName.SMALLEST, 0])}
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;
